import { styled } from '../../styles';
import { getBorderRadiusProps, getPadding } from '../../util/buttons';
import { BOTTOM_ROW_ELEMENT_HEIGHT_REM } from '../../util/constants';
export const DISABLED_COLOR = 'grey30';
export const Button = styled.button(({ backgroundColor, hoverBackgroundColor, theme, skipHoverStyling, roundLeftEdgeYn, roundRightEdgeYn, }) => {
    const backgroundColorValue = backgroundColor
        ? theme.colors[backgroundColor]
        : 'transparent';
    const hoverBackgroundColorValue = hoverBackgroundColor
        ? theme.colors[hoverBackgroundColor]
        : backgroundColorValue;
    const borderRadiusProps = getBorderRadiusProps(roundLeftEdgeYn, roundRightEdgeYn);
    const hoverStyling = skipHoverStyling
        ? {}
        : {
            cursor: 'pointer',
            backgroundColor: hoverBackgroundColorValue,
        };
    const paddingProps = getPadding(roundLeftEdgeYn, roundRightEdgeYn);
    return {
        backgroundColor: backgroundColorValue,
        minWidth: '4.25rem',
        transition: 'background-color 300ms linear',
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '.25rem',
        border: 'none',
        height: `${BOTTOM_ROW_ELEMENT_HEIGHT_REM}rem`,
        ...borderRadiusProps,
        ...paddingProps,
        ':not(:disabled):hover': hoverStyling,
        ':disabled': {
            cursor: 'not-allowed',
            color: DISABLED_COLOR,
            fill: DISABLED_COLOR,
        },
        ':focus-visible': {
            outline: 'none',
            boxShadow: 'inherit', // override global_styles.tsx
        },
    };
});
//# sourceMappingURL=icon_button_with_label.styles.js.map